import { z } from 'zod'
import {
  isCalendarMonth,
  seasonStartMonthsAreValid,
  toCalendarMonth,
  type CalendarMonth,
} from '../helpers/seasons.js'

/**
 * A month number the season settings will store.
 *
 * The range checks reject 0 and 13. The transform is what makes the result a
 * month rather than any integer that happened to fall in range: `z.infer`
 * of min and max is still `number`.
 */
const monthSchema = z
  .number()
  .int()
  .min(1)
  .max(12)
  .transform((value): CalendarMonth => {
    if (!isCalendarMonth(value)) {
      throw new Error('Enter a month from 1 to 12')
    }
    return toCalendarMonth(value)
  })

/**
 * The month each season starts in, as a set.
 *
 * Validated whole, and sent whole: whether spring may start in January
 * depends on when winter does, so a patch of one month could not be checked
 * on its own.
 */
export const seasonStartMonthsSchema = z
  .object({
    WINTER: monthSchema,
    SPRING: monthSchema,
    SUMMER: monthSchema,
    FALL: monthSchema,
  })
  .strict()
  .refine(
    seasonStartMonthsAreValid,
    'Seasons go winter, spring, summer, fall, each at least a month long',
  )
